import React, { Component } from 'react';
import classnames from 'classnames';
import _ from "lodash";
import moment from 'moment';
import Select, { components } from 'react-select';
import ScheduleModal from './ScheduleModal';
import DeleteModal from './DeleteModal';
import Loading from '../../common/Loading';
import utils from '../../../lib/utils';
import userIcon from '../../../assets/images/user_icon.svg';
import downArrow from '../../../assets/images/down_arrow.svg';
import downArrowBlue from '../../../assets/images/down_arrow_blue.svg';
import edit from '../../../assets/images/edit.svg';
import copy from '../../../assets/images/copy.svg';
import deleteIcon from '../../../assets/images/delete.svg';

import './index.scss';

const scheduleTypes = {
    'WEEKLY':'every week',
    'WEEKLY1':'every other week'
}

const filterBytype = [
    {label:'By Provider',value:'staff_ids'},
    {label:'By Operatory',value:'resource_ids'}
];

const prefrenceDropdown = {
    'HALF_AN_HOUR': 'Every half an hour',
    'TOP_OF_HOUR': 'Top of the hour',
    'EVERY_HOUR': 'Every hour',
    'EVERY_FIFTEEN_MINUTES': 'Every fifteen minutes',
    'EVERY_TWENTY_MINUTES': 'Every twenty minutes',
    'EVERY_TEN_MINUTES': 'Every ten minutes',
    'NONE': 'None',
};

const dropdownCustomStyle = {

    container: base => ({
        ...base,
        width:'200px'
      }),

    control: base => ({
      ...base,
      border: '1px solid #CFD0D1',
      // This line disable the blue border
      padding: '6px',
      boxShadow: 'none',
      outLine:'none',
      '&:hover': {
        border: '1px solid #CFD0D1',
      }
    }),
    valueContainer: base => ({
      ...base,
      padding: '0px',
      width:'104px'
    }),
  };

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="material-icons custom">arrow_drop_down</i>
        </components.DropdownIndicator>
      )
    );
  };

  const CustomOption = ({ innerProps, label, isSelected }) => {
    console.log('isSelected',isSelected);
    return <div {...innerProps} className="custom-input-option">
      <input className="custom-input-select" type="checkbox" checked={isSelected} readOnly />
      <span className="custom-input-option_lable">{label}</span>
    </div>
  };

  const sortDataBy =(data, byKey, order)=>{
    let sortedData;
    if(byKey == 'time'){
      sortedData = data.sort(function(a,b){
        let x = a.time_slot.start.toLowerCase();
        let y = b.time_slot.start.toLowerCase();
        if(x>y){return 1*order;}
        if(x<y){return -1*order;}
        return 0;
      });
    }else if(byKey == 'operatory'){
        sortedData = data.sort(function(a,b){
          let x = Array.isArray(a.resource_ids) && a.resource_ids.length > 0 && typeof a.resource_ids[0] === 'string'
                    ? a.resource_ids[0].toLowerCase()
                    : null;

          let y = Array.isArray(b.resource_ids) && b.resource_ids.length > 0 && typeof b.resource_ids[0] === 'string'
                    ? b.resource_ids[0].toLowerCase()
                    : null;

          if(x>y){return 1*order;}
          if(x<y){return -1*order;}
          return 0;
        });
    } else if(byKey == 'provider'){
        sortedData = data.sort(function(a,b){
           let x = Array.isArray(a.staff_ids) && a.staff_ids.length > 0 && typeof a.staff_ids[0] === 'string'
                    ? a.staff_ids[0].toLowerCase()
                    : null;
                    let y = Array.isArray(b.staff_ids) && b.staff_ids.length > 0 && typeof b.staff_ids[0] === 'string'
                    ? b.staff_ids[0].toLowerCase()
                    : null;
          if(x>y){return 1*order;}
          if(x<y){return -1*order;}
          return 0;
        });
    } else if(byKey == 'interval'){
        sortedData = data.sort(function(a,b){
          let x = a.booking_interval.toLowerCase();
          let y = b.booking_interval.toLowerCase();
          if(x>y){return 1*order;}
          if(x<y){return -1*order;}
          return 0;
        });
    }else if(byKey == 'appointment_type'){
        sortedData = data.sort(function(a,b){
          let x = a.service_ids.length;
          let y = b.service_ids.length;
          if(x>y){return 1*order;}
          if(x<y){return -1*order;}
          return 0;
        });
    }else{
      sortedData = data.sort((a,b)=>{
        let x = moment.duration(a.duration).format('mm');
        let y = moment.duration(b.duration).format('mm');
        console.log('XY',x,y);
        if(x>y){return 1*order;}
        if(x<y){return -1*order;}
        return 0;
        })
    }
    return sortedData;
  }
  const filterServiceForAPI = (services) => {
    const filterdService = services? services.filter(service=>service.kind==='SESSION'):[];
    return filterdService;
  }

  
export default class ServiceSchedule extends Component {
    constructor() {
        super();
        this.state = {
            sortField: 'time',
            sortOrder:1,
            schedule:[],
            loading:false,
            groupByKey: 'staff_ids',
            modalVisibility:false,
            selectedData:{},
            editSchedule:false,
            duplicateSchedule:false,
            editScheduleData:{},
            deletemodalVisibility:false,
            currentPageMap:[],
            totalPageMap:[],
            countPerPage:5,
            displayDataParsed:[],
            sortFieldMap:[],
            sortOrderMap:[],
            showFailurePopup:false,
            showDeleteSuccessPopup:false
        };
      } 
    
    componentDidMount(){
        const { auth, business } = this.props;
        const {  studio_id } = auth;
        const { countPerPage } = this.state;
        const bzid = this.props.business.id || studio_id;  
        if(bzid){
            this.props.getBusinessDetails(bzid);
        }
        if(business?.businessDetailsFetched && !utils.isEmptyObject(business?.details)){
            const data = {
                location_id: business?.details?.locations[0]?.id,
                business_id: business.id
            }
            this.props.getSchedule(data);
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.business?.businessDetailsFetched!== nextProps.business?.businessDetailsFetched && nextProps.business?.businessDetailsFetched && !utils.isEmptyObject(nextProps.business?.details)){
            const data = {
                location_id: nextProps.business?.details?.locations[0]?.id,
                business_id: nextProps.business.id
            }
            this.props.getSchedule(data);
        }
        if(this.props.schedules.scheduleDefinitionFetch === false && nextProps.schedules.scheduleDefinitionFetch === true){
            this.setState({
                loading:true
            })
       }else if(this.props.schedules.scheduleDefinitionFetch === true && nextProps.schedules.scheduleDefinitionFetch === false){
            this.setState({
                schedule:nextProps.schedules.scheduleDefinition?.staff_schedules,
                loading:false,
                displayDataParsed:this.getDataBasedOnGrouping(nextProps.schedules.scheduleDefinition?.staff_schedules, nextProps.schedules?.staff_list , this.state.groupByKey)
            })
       }
       if(this.props.schedules.addScheduleDefinition === true && nextProps.schedules.addScheduleDefinition === false){
          this.setState({
                schedule:nextProps.schedules.scheduleDefinition?.staff_schedules,
                loading:false,
                displayDataParsed:this.getDataBasedOnGrouping(nextProps.schedules.scheduleDefinition?.staff_schedules, nextProps.schedules?.staff_list,  this.state.groupByKey)
            },()=>{this.closeModal()})    
        }

        if(this.props.schedules.deleteScheduleDefinition === true && nextProps.schedules.deleteScheduleDefinition === false){
            this.setState({
                  schedule:nextProps.schedules.scheduleDefinition?.staff_schedules,
                  loading:false,
                  displayDataParsed:this.getDataBasedOnGrouping(nextProps.schedules.scheduleDefinition?.staff_schedules, nextProps.schedules?.staff_list,  this.state.groupByKey)
              },()=>{this.closeModal()})
          }
          if(this.props.schedules.deleteScheduleDefinition === true && nextProps.schedules.deleteScheduleDefinition === false && !nextProps.schedules.deleteScheduleDefinitionSuccess){
            this.failurePopup()
          }
          if(this.props.schedules.addScheduleDefinition === true && nextProps.schedules.addScheduleDefinition === false && !nextProps.schedules.addScheduleDefinitionSuccess){
            this.failurePopup()
        }
        
    }

    failurePopup = () => {
        this.setState({
          showFailurePopup: true
        })
        setTimeout(() => {
          this.setState({
            showFailurePopup: false
          })
        }, 3000);
    }

    sortType=(index, field, order)=>{
            let sortFieldMapTemp = this.state.sortFieldMap.slice();
            let sortOrderMapTemp = this.state.sortOrderMap.slice();
            sortFieldMapTemp[index] = field;
            sortOrderMapTemp[index] = order
        this.setState({
            sortFieldMap: sortFieldMapTemp,
            sortOrderMap: sortOrderMapTemp
        })
    }

    getDataBasedOnGrouping = (schedule, staff_list, groupByKey) =>{
        const { sortField , sortOrder , loading , countPerPage} = this.state;
        const { business, schedules } = this.props;
        const groupedSchedul =  _.groupBy(schedule,(time)=>time[groupByKey]);
        //serviceById["NX-19370-P-1"].name
        const staffs = staff_list || business?.details?.staffs;
        console.log('Staffs',this.props.schedules);
        const listArray = groupByKey === 'staff_ids'? staffs :business?.details?.resources;
        const displayData = listArray?.map(item=>({
            groupingData:item,
            schedules: groupedSchedul[item.id] || []
        }));
        const displayDatatemp = Object.keys(groupedSchedul).map(key=>{
        const groupingData = groupByKey === 'staff_ids'?business.staffById[key]:business?.details?.resources.filter(resource=>resource.id===key)[0]
        return {
                groupingData,
                schedules : groupedSchedul[key],
            }
        })
        const totalPageMap = displayData.map((group)=>(Math.ceil(group.schedules.length/countPerPage) || 0) )
        const currentPageMap = displayData.map((group)=>1);
        const sortFieldMap = displayData.map((group)=>'time')
        const sortOrderMap = displayData.map((group)=>1)
    
        console.log('displayData',displayDatatemp,displayData, totalPageMap)
        this.setState({
            totalPageMap ,
            currentPageMap,
            sortFieldMap,
            sortOrderMap
        })
        return displayData || [];

    }
    getServiceName=(service_ids)=>{
        const { business } = this.props;
        const { services } = business.details;
        const ifAllService = _.isEqual(_.sortBy(service_ids), _.sortBy(filterServiceForAPI(services).map(service=>service?.id)))
        if(ifAllService){
            return ['All Service'];
        }
        const servicenames = service_ids?.map(serviceId=>business?.serviceById[serviceId]?.name);
        console.log('loading----->',servicenames);
        return servicenames;
    }
    getOperatoryName=(operatory)=>{
        const { business } = this.props;
        const resource = business?.details?.resources.filter(resource=>resource.id===operatory[0]);
        return resource.length>0?resource[0].name:'';
    }
    getProviderName=(provider)=>{
        const { business } = this.props;
        const resource = business?.staffById[provider[0]];
        return resource?.name || '';
    }

    openModal =(selectedData)=>{
        this.setState({
            modalVisibility:true,
            selectedData
        })
    }
    closeModal =()=>{
        this.setState({
            modalVisibility:false,
            deletemodalVisibility:false,
            duplicateSchedule:false,
            editSchedule:false,
            editScheduleData:{}
        })
    }
    onViewFilterChange=(event)=>{
        console.log('EVENT',event);
        let val = event.target.value.value;
        this.setState({
          [event.target.name]: val,
          displayDataParsed:this.getDataBasedOnGrouping(this.props.schedules.scheduleDefinition?.staff_schedules, this.props.schedules?.staff_list,  val)
        })
        console.log('STATE',this.state);
    }
    onEditClick=(data, groupingData)=>{
        this.setState({
            modalVisibility:true,
            editSchedule:true,
            editScheduleData:data,
            selectedData:groupingData
        })
    }

    onDuplicateClick=(data, groupingData)=>{
        this.setState({
            modalVisibility:true,
            duplicateSchedule:true,
            editScheduleData:data,
            selectedData:groupingData
        })
    }

    onDeleteClick=(data)=>{
        this.setState({
            deletemodalVisibility:true,
            editScheduleData:data
        })
        
    }
    deleteSchedule=(data)=>{
        const { auth, business } = this.props;
        const {  studio_id } = auth;
        const bzid = business.id || studio_id;  
        data.schedule_id = data.id;
        this.props.deleteScheduleAPI({data:data ,business_id: bzid  })
    }
    getPages=(index)=>{
        const {  totalPageMap } = this.state;
        const totalPage = totalPageMap[index];
        let pages = [];
        for(let i=0;i<totalPage;i++){
            pages.push(i+1);
        }
        return pages;
    }

    changePage=(page,index)=>{
        let currentPageMapTemp = this.state.currentPageMap.slice();
        currentPageMapTemp[index] = page;
        this.setState({
            currentPageMap:currentPageMapTemp
        })
    }
    nextPage=(index)=>{
        const { currentPageMap, totalPageMap} = this.state;
        let currentPageMapTemp = this.state.currentPageMap.slice();
        currentPageMapTemp[index] += 1; 
        if(currentPageMap[index]<totalPageMap[index]){
            this.setState({
                currentPageMap: currentPageMapTemp
            })
        }
    }
    prevPage=(index)=>{
        const { currentPageMap} = this.state;
        let currentPageMapTemp = this.state.currentPageMap.slice();
        currentPageMapTemp[index] -= 1; 
        if(currentPageMap[index]>1){
            this.setState({
                currentPageMap: currentPageMapTemp
            })
        }
    }

    getServices=(schedule, index)=>{
        const { currentPageMap, countPerPage, sortFieldMap,sortOrderMap} = this.state;
        console.log('SORT',sortDataBy(schedule, sortFieldMap[index], sortOrderMap[index]), schedule, sortFieldMap[index], sortOrderMap[index])
        let sortedschedule = schedule.length>0? sortDataBy(schedule, sortFieldMap[index], sortOrderMap[index]): [];
        const start = ((currentPageMap[index]-1)*countPerPage);
        const end = currentPageMap[index]*countPerPage> sortedschedule.length ? sortedschedule.length:currentPageMap[index]*countPerPage;
        console.log('sortedschedule',sortedschedule);
        return sortedschedule.slice(start, end);
    }
    
    render() {
        const { sortField , sortOrder , loading , modalVisibility, 
            groupByKey, selectedData,  editSchedule, editScheduleData, duplicateSchedule, deletemodalVisibility,
            currentPageMap, totalPageMap , countPerPage, schedule, displayDataParsed, sortFieldMap,sortOrderMap, showFailurePopup} = this.state;
        const { business, auth, schedules } = this.props;
        const {  studio_id } = auth;
        const bzid = this.props?.business?.id || studio_id; 
        const pmsList = business?.details?.locations?.length>0? business.details?.locations[0].location_metadata?.associated_pms:null;
        console.log('displayDataParsed', displayDataParsed);
        return <div className="serviceschedule">
            <div className='serviceschedule_title'>
                <div className="serviceschedule_title_content">
                    <div className="title">Schedule Definition</div>
                    <div className="period-filter-sync">
                    <div className='period-filter-sync_action'>
                    <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={filterBytype.filter(c => c.value === groupByKey)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={filterBytype}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onViewFilterChange({target:{name:'groupByKey', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                    <div className="period-filter-sync_action_save"><button className="btn btn--primary btn--lg" onClick={()=>this.props.syncServiceTypes(bzid)} disabled={schedules.syncBusiness}>{schedules.syncBusiness?'SAVING..':'SAVE'}</button></div>
                    </div>
                    </div>
                </div>
                <div className='serviceschedule_title_pms'><div>{pmsList}</div> <div className='serviceschedule_title_pms_synctime'>Last updated: {moment(business?.details?.last_sync_time).fromNow()}</div></div>
            </div>
            {loading?
            (<div className="serviceschedule_loader">
            <Loading />
            </div>):
            (<div className="serviceschedule_content">
                {displayDataParsed.sort((a, b) => {
                    if (a.length === 0) return -1; 
                    if (b.length === 0) return 1;
                    return 0; 
                    }).map((group,index)=>
                    <div className="serviceschedule_content_data">
                        <div className="serviceschedule_content_data_nameaction">
                            <div className="name-info">
                                {groupByKey === 'staff_ids' &&
                                <div className="name-info_icon">
                                    <img src={userIcon} />
                                </div> }
                                <div className="name-info_details">
                                    <div className="name-info_details_name">{group.groupingData.name}</div>
                                    <div className="name-info_details_designation">{groupByKey === 'staff_ids'?(group.groupingData?.staff_metadata?.speciality) +' ('+group.groupingData?.staff_metadata?.pmsId +')':'Operatory'}</div>
                                </div>
                            </div>
                            <div className="add-time">
                                    <div className="add-time_button" onClick={()=>this.openModal(group.groupingData)}>+ Add time</div>
                            </div>
                        </div>
                        <div className="serviceschedule_content_data_schedules">
                            <div className="header">
                               <div className="field time">TIME  <img className={classnames('arrow',{'rotate-arrow':(sortOrderMap[index]=== -1 && sortFieldMap[index]==='time')})}  src={sortFieldMap[index]!=='time'?downArrow:downArrowBlue} onClick={()=>this.sortType(index,'time',sortOrderMap[index]*-1)}/> </div>     
                               <div className="field appointment_type">APPOINTMENT TYPE  <img className={classnames('arrow',{'rotate-arrow':(sortOrderMap[index]=== -1 && sortFieldMap[index]==='appointment_type')})}  src={sortFieldMap[index]!=='appointment_type'?downArrow:downArrowBlue} onClick={()=>this.sortType(index,'appointment_type',sortOrderMap[index]*-1)}/> </div>     
                               {groupByKey === 'staff_ids'? (<div className="field operatory">OPERATORIES  <img className={classnames('arrow',{'rotate-arrow':(sortOrderMap[index]=== -1 && sortFieldMap[index]==='operatory')})}  src={sortFieldMap[index]!=='operatory'?downArrow:downArrowBlue} onClick={()=>this.sortType(index,'operatory',sortOrderMap[index]*-1)}/> </div> )
                               :(<div className="field operatory">PROVIDERS  <img className={classnames('arrow',{'rotate-arrow':(sortOrderMap[index]=== -1 && sortFieldMap[index]==='provider')})}  src={sortFieldMap[index]!=='provider'?downArrow:downArrowBlue} onClick={()=>this.sortType(index,'provider',sortOrderMap[index]*-1)}/> </div>)}    
                               <div className="field interval">BOOKING INTERVALS  <img className={classnames('arrow',{'rotate-arrow':(sortOrderMap[index]=== -1 && sortFieldMap[index]==='interval')})}  src={sortFieldMap[index]!=='interval'?downArrow:downArrowBlue} onClick={()=>this.sortType(index,'interval',sortOrderMap[index]*-1)}/> </div>
                               <div className="field empty">
                                    {/* <img  src={edit} />
                                    <img src={copy} />
                                    <img src={deleteIcon} /> */}
                                </div>   
                            </div>
                            <div className="body">
                            {group.schedules.length>0?
                            (<>{this.getServices(group.schedules,index).map(schedule=>
                            <div className="body_schedule">
                                <div className="body_schedule_datetime">
                                    <div className="days">
                                        {schedule.schedule_type==='WEEKLY' && <div className="days_ofweek">{schedule.days.map((day,index)=><div>{moment(day,'dddd').format('ddd')}{index<schedule.days.length-1?',\xa0':''}</div>)}</div>}
                                        {schedule.schedule_type==='SPECIFIC_DATE' && <div className="days_ofweek">{moment(schedule.date,'YYYY-MM-DD').format('MMM DD, YYYY')}</div>}
                                        {schedule.schedule_type==='RECURRENCE' && <div className="days_ofweek"> Every {schedule?.recurrence_count>1?schedule.recurrence_count:''} {schedule?.recurrence_unit?.toLowerCase().replace(/ly\b/g, '')}{schedule?.recurrence_count>1?'s':''} starting from <br/> {moment(schedule.date,'YYYY-MM-DD').format('MMM DD, YYYY')}</div>}
                                        <div className="days_ofmonth">{scheduleTypes[schedule.schedule_type]}</div>
                                    </div>
                                    <div className="times">
                                        <div className="start-end">{moment(schedule.time_slot.start,'HH:mm:ss').format('hh:mm A')} - {moment(schedule.time_slot.end,'HH:mm:ss').format('hh:mm A')}</div>
                                        <div className="break-time">{schedule.schedule_breaks?.map(slot=><div>Break {moment(slot.start,'HH:mm:ss').format('h:mm a')} - {moment(slot.end,'HH:mm:ss').format('h:mm a')} </div>) }</div>
                                    </div>
                                </div>
                                <div className="body_schedule_appointment_type">{this.getServiceName(schedule.service_ids).slice(0, 4).map(servicename=><div>{servicename}</div>)}</div>
                                {groupByKey === 'staff_ids'? (<div className="body_schedule_operatory">{this.getOperatoryName(schedule.resource_ids)}</div>):
                                (<div className="body_schedule_provider">{this.getProviderName(schedule.staff_ids)}</div>)}
                                <div className="body_schedule_interval">{prefrenceDropdown[schedule.booking_interval]}</div>
                                <div className="body_schedule_empty">
                                    {!schedule?.synced_from_pms &&
                                    <div className="body_schedule_empty_wrapper">
                                    <img onClick={()=>this.onEditClick(schedule, group.groupingData)} src={edit} />
                                    <img src={copy}   onClick={()=>this.onDuplicateClick(schedule, group.groupingData)} />
                                    <img src={deleteIcon}  onClick={()=>this.onDeleteClick(schedule, group.groupingData)}/>
                                    </div>
                                    }
                                </div>
                            </div>)}
                        <>
                        {group?.schedules?.length>5 &&
                        <div className="schedule_title_table_pagination">
                            <div className="count">Showing {((currentPageMap[index]-1)*countPerPage)+1}-{currentPageMap[index]*countPerPage>group.schedules.length ? group.schedules.length:currentPageMap[index]*countPerPage} of {group.schedules.length} entries</div>
                            <div className="paging">
                                {currentPageMap[index]!== 1 && <span className={classnames('page-number')} onClick={()=>this.prevPage(index)}>PREV</span>}
                                {this.getPages(index).map(page=><span className={classnames('page-number',{'active':page===currentPageMap[index]})} onClick={()=>this.changePage(page,index)}>{page}</span>)}
                                {totalPageMap[index]!==currentPageMap[index] && <span className={classnames('page-number')} onClick={()=>this.nextPage(index)}>NEXT</span>}
                            </div>
                        </div>}
                        </>
                            
                            </>):
                            (<div className="no-data">No schedule for this provider. Add time to get started.</div>)}
                            </div>
                        </div>
                        
                        
                        
                        </div>)}
                     </div>)}
            {showFailurePopup && schedules.errorMessage && <div className="copy-webhook-failure">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                    {schedules.errorMessage}
            </div>}
               {modalVisibility && <ScheduleModal business={business} modelopen={modalVisibility} groupByKey={groupByKey} selectedData={selectedData} addSchedule={this.props.addSchedule} editScheduleAPI={this.props.editScheduleAPI} bzid={bzid} closeServiceModal={this.closeModal} editSchedule={editSchedule}  editScheduleData={editScheduleData} duplicateSchedule={duplicateSchedule} {...this.props}/>}
               {deletemodalVisibility && <DeleteModal  modelopen={deletemodalVisibility}schedules={schedules} closeServiceModal={this.closeModal} deleteSchedule={this.deleteSchedule} deleteData={editScheduleData} {...this.props}/>}
                </div>
        
}
}